/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Done/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Done({
  children,
  viewPath = "/App/Account/Content/Marketing/ReportTable/Content/Content/Content/Download/DownloadCSV/Content/Done"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 size="normal"
 text="Done"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../DownloadAction'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../DownloadAction'))}
/>
{children}
</React.Fragment>)
}